import { fetchApi } from "../fetchApi";

export async function exclamationSubscription(model) {
  const raw = JSON.stringify({
    jsonrpc: "2.0",
    method: "call",
    params: {
      args: [],
      model: model,
      method: "exclamation_subscription",
      kwargs: {},
    },
  });

  const requestOptions = {
    method: "POST",
    body: raw,
    redirect: "follow",
  };
  const response = await fetchApi({
    requestOptions,
    endpoint: `/web/dataset/call_kw/${model}/exclamation_subscription`,
  });

  return JSON.parse(response);
}
